import React, { useState } from "react";
import { X } from "lucide-react";

export default function BkashPaymentModal({
  open,
  amount,
  onClose,
  onConfirm,
  trxId,
  setTrxId,
}) {
  const [error, setError] = useState("");

  if (!open) return null;

  const handleConfirm = () => {
    if (!trxId.trim()) {
      setError("Transaction ID is required");
      return;
    }
    onConfirm(trxId);
    setTrxId("");
    setError("");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-lg min-w-0">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="text-sm font-extrabold text-black/80">
            Pay with bKash
          </div>
          <button onClick={onClose} className="rounded-lg p-1 hover:bg-black/5">
            <X className="h-5 w-5 text-black/60" />
          </button>
        </div>

        {/* Amount */}
        <div className="mt-2 text-xs font-semibold text-black/60">
          Amount to pay
        </div>
        <div className="text-lg font-black text-orange-600">{amount}</div>

        {/* QR */}
        <div className="mt-4 flex justify-center">
          <img
            src="/bkash.png" // replace with your QR
            alt="bKash QR Code"
            className="h-44 w-44 rounded-xl border"
          />
        </div>

        {/* Instructions */}
        <div className="mt-4 text-xs font-medium text-black/60 space-y-1">
          <div>1️⃣ Open your bKash app</div>
          <div>2️⃣ Scan the QR code or go to Send Money</div>
          <div>
            3️⃣ Enter the recipient number: <strong>01319940717</strong>
          </div>
          <div>4️⃣ Send the amount shown above</div>
          <div>5️⃣ Enter the Transaction ID below</div>
        </div>

        {/* TrxID */}
        <div className="mt-4">
          <label className="text-xs font-bold text-black/70">
            bKash Transaction ID (TrxID)
          </label>
          <input
            value={trxId}
            onChange={(e) => setTrxId(e.target.value)}
            placeholder="e.g. A7B9C2D"
            className="mt-2 h-11 w-full rounded-xl border border-black/10 px-4 text-sm outline-none focus:ring-2 focus:ring-orange-600/25"
          />
          {error && (
            <div className="mt-1 text-xs font-semibold text-red-600">
              {error}
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="mt-5 flex gap-2">
          <button
            onClick={onClose}
            className="h-11 w-full rounded-xl border border-black/10 bg-white text-sm font-semibold text-black/70 hover:bg-black/5"
          >
            Cancel
          </button>

          <button
            onClick={handleConfirm}
            className="h-11 w-full rounded-xl bg-orange-600 text-sm font-semibold text-white hover:bg-orange-700"
          >
            Place Order
          </button>
        </div>
      </div>
    </div>
  );
}
